import { createSlice } from '@reduxjs/toolkit';

const initialColor = localStorage.getItem('theme');

export const headerSlice = createSlice({
  name: 'header',
  initialState: {
    themeColor: initialColor || 'light',
  },
  reducers: {
    setThemeColor: (state, action) => {
      state.themeColor = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setThemeColor } = headerSlice.actions;

export default headerSlice.reducer;
